import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';
import { CmsApiResponse, CmsPageService } from '../../services/cms-page.service';
import { AboutCmsContent } from '../../models/types';
import {
  DEFAULT_ABOUT_CMS,
  parseAboutCmsContent,
} from '../../config/about-cms.defaults';

@Component({
  selector: 'app-about-page',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './about-page.component.html',
})
export class AboutPageComponent implements OnInit, OnDestroy {
  state = inject(AppStateService);
  private route = inject(ActivatedRoute);
  private cmsPageService = inject(CmsPageService);
  private routeSub?: Subscription;

  loading = signal(true);
  cms = signal<AboutCmsContent>(DEFAULT_ABOUT_CMS);

  ngOnInit() {
    this.routeSub = this.route.data.subscribe((data) => {
      this.applyCmsResponse(data['cmsResponse'] as CmsApiResponse | null);
    });
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }

  private applyCmsResponse(res: CmsApiResponse | null) {
    this.loading.set(true);

    const content =
      res?.status && res.data?.content
        ? parseAboutCmsContent(res.data.content)
        : DEFAULT_ABOUT_CMS;

    this.cms.set(content);
    this.cmsPageService.applyPageSeo(content.seo);
    this.loading.set(false);
  }
}
